import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { cargarCatalogosGenericoAsync} from '../../funciones_globales/catalogos';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import '../componentes_generales/componentes_formulario/contenedores/flexbox.css'
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';

class FormCli14 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            //Global

            cliente_sel: null,
            vendedor_sel: null,

            operacion: 'G', //G GUARDAR - M Modificar
            permiso: null, //G SOLO GUARDAR => M Guardar & Modificar
            tipoPersona: 'N',
            opcionReporte: 'L'
        };

        this.limpiar = this.limpiar.bind(this);
        this.imprimir = this.imprimir.bind(this);
        this.actualizarCampos = this.actualizarCampos.bind(this);
    }

    actualizarCampos(event){
        const target = event.target;       
        const name = target.name;    
        const value = target.type === 'checkbox'? target.checked : target.value;
        this.setState({[name]: value});
    }

    componentDidMount(){
        this.props.generar_LogAuditoriaIngresoForm('0114')
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0114');
    }

    imprimir(){
        try{
            let urlReportWithParams=this.state.opcionReporte==='L'?`&rpt=92`:this.state.tipoPersona==='N'?`&rpt=95`:`&rpt=96`; 

            if(this.state.opcionReporte==='O'){
                urlReportWithParams+=`&param1=${this.state.tipoPersona}`;
            }

            if(this.state.cliente_sel){
                urlReportWithParams+=this.state.opcionReporte==='L'?`&param1=${this.state.cliente_sel.value}`:`&param2=${this.state.cliente_sel.value}`;
            }

            if(this.state.vendedor_sel){
                urlReportWithParams+=this.state.opcionReporte==='L'?`&param2=${this.state.vendedor_sel.value}`:`&param3=${this.state.vendedor_sel.value}`;
            }

            urlReportWithParams+=`&nomlogo=${'001.png'}`;
            visualizarReporteEnPdf(urlReportWithParams);
            
        }catch(error){
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }

    limpiar(){
        this.setState({cliente_sel: null, vendedor_sel: null})
    }

    getOptions_Clientes(input, callback){
        if (input.toString().length >= 2 ){
          let query = "?tipo=catalogo&cadena_busq=" + input;
          cargarCatalogosGenericoAsync('/clientes', query, callback)
        }
    }

    getOptions_Vendedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '?cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/vendedores', cadena_busq, callback)              
        }
    }

    render(){
        return (
            <ContenedorForm porc_ancho={55}>
                <HeaderForm>
                    <TituloForm>Declaración Origen Lícito de Recursos</TituloForm>
                </HeaderForm>
                <CuerpoForm>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-6'>
                            <LabelForm className='radio-inline'>
								<input type="radio" name="opcionReporte" value="L" checked={this.state.opcionReporte==="L"} onChange={this.actualizarCampos} />
								Licitud Cliente
							</LabelForm>
                            <LabelForm className='radio-inline'>
								<input type="radio" name="opcionReporte" value="O" checked={this.state.opcionReporte==="O"} onChange={this.actualizarCampos} />
								Por Tipos
							</LabelForm>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10} isInvisible={this.state.opcionReporte==='L'?true:false}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Tipo Cliente:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>
                            <LabelForm className='radio-inline'>
								<input type="radio" name="tipoPersona" value="N" checked={this.state.tipoPersona==="N"} onChange={this.actualizarCampos} />
								Natural
							</LabelForm>
                            <LabelForm className='radio-inline'>
								<input type="radio" name="tipoPersona" value="J" checked={this.state.tipoPersona==="J"} onChange={this.actualizarCampos} />
								Jurídico
							</LabelForm>
                        </ContainerCol>
                    </Row> 
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Cliente:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>
                            <ReactSelectAsync value={this.state.cliente_sel} func_loadOptions={this.getOptions_Clientes} func_onChange={(value)=>{this.setState({cliente_sel: value!==null?value:null})}}/>
                        </ContainerCol>
                    </Row>  
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Vendedor:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>
                            <ReactSelectAsync value={this.state.vendedor_sel} func_loadOptions={this.getOptions_Vendedores} func_onChange={(value)=>{this.setState({vendedor_sel: value!==null?value:null})}}/>
                        </ContainerCol>
                    </Row>

                    <Row margen_arriba={20}>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-info btn-sm' onClick={this.imprimir}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                                <button type="button" className='btn btn-sm' onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});

export default connect (null, mapDispatchToProps)(FormCli14);